import { Modal } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { useOrganizationUiSetup } from '../../../../../../../../hooks/useOrganizationUiSetup'
import { InviteUserModalContextProvider } from './context/inviteUserModalContext'
import { InviteUserForm } from './elements/InviteUserForm'
import { ModalFooter } from './elements/ModalFooter'
import { ReadMore } from './elements/ReadMore'

export const InviteUsersModal = (): ReactElement => {
  const { t } = useTranslation()
  const { isUiSetupShineInvoicingAccounting } = useOrganizationUiSetup()

  return (
    <InviteUserModalContextProvider>
      <Modal id={ModalId.OrganizationSettingsInviteUsersModal} size="s" closable>
        <Modal.Header title={t('settings.organization.users.invite_user_modal.title')} />
        <Modal.Body>
          <InviteUserForm />
          {/* Temporarily disabling ReadMore link until articles for multi-user in Shine Facture are ready */}
          {!isUiSetupShineInvoicingAccounting && <ReadMore />}
        </Modal.Body>
        <Modal.Footer>
          <ModalFooter />
        </Modal.Footer>
      </Modal>
    </InviteUserModalContextProvider>
  )
}
